import script from "./property-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./property-detail.vue?vue&type=script&setup=true&lang=js"

import "./property-detail.vue?vue&type=style&index=0&id=3343a65b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3343a65b"]])

export default __exports__